import CollectionView from 'views/base/collection-view';
import CustomContentCollectionTemplate from './templates/custom-content-collection';
import CustomContentItemView from './custom-content-item-view';
import Chaplin from 'chaplin';
import $ from 'jquery';

const CustomContentView = CollectionView.extend({
  autoRender: false,
  template: CustomContentCollectionTemplate,
  listSelector: '.custom-content-items',
  itemView: CustomContentItemView,
  animationDuration: 0,
  render() {
    if (!this.collection || this.collection.length === 0) {
      this.trigger('done');
    } else {
      const custom_id = this.collection.at(0).get('custom_id');

      $(this.el).on('click', e => {
        if (e.target.href) {
          const currentURL = new RegExp(location.host);
          if (!currentURL.test(e.target.href)) {
            Chaplin.mediator.publish('interstitial-page:external-link-clicked', custom_id);
          }
        }
      });

      Chaplin.mediator.publish('interstitial-page:view', custom_id);
      this.collection.on('change:done', () => {
        if (this.collection.every(cc => cc.get('done'))) {
          $(this.el).off('click');
          Chaplin.mediator.publish('interstitial-page:done', custom_id);
          this.trigger('done');
        }
      });
    }
    CollectionView.prototype.render.apply(this, arguments);
  },
  getTemplateData: Chaplin.View.prototype.getTemplateData,
});

export default CustomContentView;
